exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-not-available-index-jsx": () => import("./../../../src/templates/NotAvailable/index.jsx" /* webpackChunkName: "component---src-templates-not-available-index-jsx" */),
  "component---src-templates-secondary-index-jsx": () => import("./../../../src/templates/Secondary/index.jsx" /* webpackChunkName: "component---src-templates-secondary-index-jsx" */)
}

